import React, { useState, useEffect } from "react";
import "./Contact.css";
import { Fade } from "react-awesome-reveal";
import HomeFaq from "../Home/HomeFaq";

const faqs = [
  {
    question: "Are there any discounts available for students?",
    answer:
      "Yes, Hamo Tech offers exclusive discounts for students. You can verify your student status during the checkout process to access special pricing.",
  },
  {
    question: "Do you have special pricing for large teams or organizations?",
    answer:
      "Absolutely! We provide tailored pricing packages for big teams or organizations. Contact our sales team for a customized quote.",
  },
  {
    question: "What qualifications and experience do your instructors have?",
    answer:
      "All our instructors are industry experts with years of practical experience in their respective fields, ensuring you learn from the best.",
  },
  {
    question: "What is your policy on course refunds?",
    answer:
      "We offer a 14-day refund policy on eligible courses if you're unsatisfied, provided you haven't completed more than 30% of the course content.",
  },
  {
    question: "Do non-profits receive any discounts on courses?",
    answer:
      "Yes, non-profits are eligible for discounts. Reach out to our support team with your organization's details to learn more.",
  },
];

const ContactUs = () => {
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const toggle = (index) => {
    setOpen(open === index ? null : index);
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);

  //form states
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!category || category === "Select Category") {
      alert("Please select a category.");
      return;
    }

    const formData = new URLSearchParams();
    formData.append("firstname", firstName);
    formData.append("lastname", lastName);
    formData.append("email", email);
    formData.append("number", number);
    formData.append("category", category);
    formData.append("message", message);

    setLoading(true);

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbyKECIvX1SFNFPfGg275wScf-fTjNCPckbG30MNaMBjAQ3417PmmJ3xeYJXVaHheELk/exec",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.result === "success") {
        alert("Data submitted successfully!");
      } else {
        alert("Error submitting form: " + result.error);
      }

      // Reset form fields
      setFirstName("");
      setLastName("");
      setEmail("");
      setNumber("");
      setCategory("");
      setMessage("");
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="floating-icons">
        <a
          className="icon"
          href="https://www.facebook.com/login.php/"
          target="_blank"
        >
          <button className="sm_icon">
            <img
              src="https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png"
              alt="facebook"
            />
          </button>
        </a>
        <a
          className="icon"
          href="https://www.instagram.com/hamotechsd/"
          target="_blank"
        >
          <button className="sm_icon">
            <img
              src="https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png"
              alt="instagram"
            />
          </button>
        </a>
        <a
          className="icon"
          href="https://www.linkedin.com/company/105967594/admin/page-posts/published/"
          target="_blank"
        >
          <button className="sm_icon">
            <img
              src="https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png"
              alt="linkedin"
            />
          </button>
        </a>
        <a className="icon" href="https://wa.me/+918688964015" target="_blank">
          <button className="sm_icon">
            <img
              src="https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png"
              alt="whatsapp"
            />
          </button>
        </a>
      </div>

      <div className="container-fluid" style={{ marginTop: "150px" }}>
        {/* <section>
        <div className="" style={{ height: "500px" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248756.13131218663!2d80.04419834948149!3d13.047473316335056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1734802722189!5m2!1sen!2sin"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            width="100%"
            height={400}
          ></iframe>
        </div>
      </section> */}

        <section className="layout-pt-md layout-pb-lg">
          <div className="container">
            <div className="row y-gap-50 justify-between">
              <div className="col-lg-4 ">
                <Fade direction="up" delay={200}>
                  <h3 className="text-24 fw-500">Keep In Touch With Us.</h3>
                  <p className="mt-25">
                    Reach out to us for innovative solutions and support. Always
                    here to help with your tech needs.
                  </p>
                  <div className="y-gap-30 pt-60 lg:pt-40">
                    <div className="d-flex items-center">
                      <div className="d-flex justify-center items-center size-60 rounded-full bg-light-7">
                        <img
                          src="https://educrat-react.vercel.app/assets/img/contact-1/1.svg"
                          alt="contact-icon"
                          className=""
                        />
                      </div>
                      <div className="ml-20">
                        10 Jalan Besar, #08-06, SIM LIM Tower, Singapore -
                        208787
                      </div>
                    </div>
                    <div className="d-flex items-center">
                      <div className="d-flex justify-center items-center size-60 rounded-full bg-light-7">
                        <img
                          src="https://educrat-react.vercel.app/assets/img/contact-1/1.svg"
                          alt="contact-icon"
                          className=""
                        />
                      </div>
                      <div className="ml-20">
                        No: 2/84 sivaprakasam nagar, Ambattur Redhills Road,
                        Surapet , Chennai, India - 600066.
                      </div>
                    </div>

                    <div className="d-flex items-center">
                      <div className="d-flex justify-center items-center size-60 rounded-full bg-light-7">
                        <img
                          src="https://educrat-react.vercel.app/assets/img/contact-1/2.svg"
                          alt="contact-icon"
                          className=""
                        />
                      </div>
                      <div className="ml-20">
                        Singapore : +(65) 89109120 <br />
                        India: +(91) 8688964015
                      </div>
                    </div>
                    <div className="d-flex items-center">
                      <div className="d-flex justify-center items-center size-60 rounded-full bg-light-7">
                        <img
                          src="https://educrat-react.vercel.app/assets/img/contact-1/3.svg"
                          alt="contact-icon"
                          className=""
                        />
                      </div>
                      <div className="ml-20">Hamotechsd@gmail.com</div>
                    </div>
                  </div>
                </Fade>
              </div>

              <div className="col-lg-7 ">
                <Fade>
                  <h3 className="text-24 fw-500">Send a Message.</h3>
                  <p
                    className="mt-25"
                    style={{ color: "#767676", fontSize: "14px" }}
                  >
                    Got questions or need assistance? We're here to help! Fill
                    out the form below, and the{" "}
                    <b style={{ color: "#ea3437" }}>Hamo Tech</b> team will get
                    back to you promptly.
                  </p>
                  <form
                    className="contact-form row y-gap-30 pt-60 lg:pt-40"
                    onSubmit={handleSubmit}
                  >
                    <div className="col-md-6">
                      <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                        First Name
                      </label>
                      <input
                        type="text"
                        required
                        name="firstname"
                        placeholder="First Name..."
                        onChange={(e) => setFirstName(e.target.value)}
                        value={firstName}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                        Last Name
                      </label>
                      <input
                        type="text"
                        required
                        name="lastname"
                        placeholder="Last Name..."
                        onChange={(e) => setLastName(e.target.value)}
                        value={lastName}
                      />
                    </div>

                    <div className="col-md-12">
                      <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                        Email
                      </label>
                      <input
                        type="email"
                        required
                        name="email"
                        placeholder="Email..."
                        className="form-control"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                      />
                    </div>

                    <div className="col-md-12">
                      <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                        Contact Number
                      </label>
                      <input
                        type="tel"
                        required
                        name="number"
                        placeholder="Contact Number..."
                        onChange={(e) => setNumber(e.target.value)}
                        value={number}
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                        Category
                      </label>
                      <select
                        className="form-control"
                        onChange={(e) => setCategory(e.target.value)}
                        value={category}
                      >
                        <option hidden>Select Category</option>
                        <option value="Student">Student</option>
                        <option value="Job Seeker">Job Seeker</option>
                        <option value="Trainer">Trainer</option>
                        <option value="Lecturer">Lecturer</option>
                        <option value="Developer">Developer</option>
                        <option value="IT Professional">IT Professional</option>
                        <option value="Non-IT">Non-IT</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                        Description
                      </label>
                      <textarea
                        required
                        name="message"
                        placeholder="Message..."
                        rows="8"
                        onChange={(e) => setMessage(e.target.value)}
                        value={message}
                      ></textarea>
                    </div>

                    {loading ? (
                      <p>Processing your request...</p>
                    ) : (
                      <div className="col-12">
                        <button
                          type="submit"
                          name="submit"
                          id="submit"
                          className="button -md -purple-1 text-white"
                        >
                          Send Message
                        </button>
                      </div>
                    )}
                  </form>
                </Fade>
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-lg layout-pb-lg bg-light-4">
          <div className="container">
            <div className="row justify-center text-center">
              <div className="">
                <Fade>
                  {/* <div className="sectionTitle ">
                  <h2 className="sectionTitle__title">
                    Frequently Asked Questions.
                  </h2>
                  <p className="sectionTitle__text ">
                    Discover answers to your questions about <b>Hamo Tech</b> with
                    ease.
                  </p>
                </div> */}
                  {/* <div className="faq">
                {" "}
                {faqs.map((faq, index) => (
                  <div key={index} className="mb-3 faq_card">
                    {" "}
                    <div className="d-flex align-items-center">
                      {" "}
                      <button
                        className="btn btn-link"
                        onClick={() => toggle(index)}
                      >
                        {" "}
                        {open === index ? (
                          <Dash size={30} />
                        ) : (
                          <Plus size={30} />
                        )}{" "}
                      </button>
                      <h5>{" "} {faq.question}</h5>{" "}
                     
                    </div>{" "}
                    {open === index && <p className="mt-3">{faq.answer}</p>}{" "}
                  </div>
                ))}{" "}
              </div> */}
                  <div className="contact_faq">
                    <HomeFaq />
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container contact_maps">
            <div className="row">
              <div className="col-lg-6">
                <div className="card">
                  <div className="add">
                    <h2>Address : </h2>
                    <p>
                      {" "}
                      10 Jalan Besar, #08-06, SIM LIM Tower, Singapore - 208787
                    </p>
                    <p style={{ visibility: "hidden" }} className="mb-0">
                      {" "}
                      10 Jalan Besar, #08-06, SIM LIM Tower, Singapore - 208787
                    </p>
                  </div>
                  <div>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7854206924408!2d103.85216357591504!3d1.3037655617202741!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19684db80055%3A0xd453f39eb70a1280!2sSim%20Lim%20Tower!5e0!3m2!1sen!2sin!4v1737892875358!5m2!1sen!2sin"
                      width="100%"
                      height="500"
                      style={{ border: 0 }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                      title="Hamo Tech Singapore Location"
                    ></iframe>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="card">
                  <div className="add">
                    <h2>Address : </h2>
                    <p>
                      {" "}
                      No: 2/84 sivaprakasam nagar, Ambattur Redhills Road,
                      Surapet , Chennai, India - 600066.
                    </p>
                  </div>
                  <div>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.3755957646486!2d80.1759891748444!3d13.138692087192277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52636f458b103f%3A0xe5091f6b9e4b6b80!2sAmbattur%20Red%20Hills%20Rd%2C%20Chennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1742065967102!5m2!1sen!2sin"
                      width="100%"
                      height="500"
                      style={{ border: "0" }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
